const proxyMouseDownToParentContext = (event) => {
  const { frameElement } = event.target.ownerDocument.defaultView;

  const mouseDownEvent = new MouseEvent('mousedown', {
    bubbles: true,
    cancelable: true,
  });

  frameElement.dispatchEvent(mouseDownEvent);
};

export default proxyMouseDownToParentContext;
